import React, { useState } from 'react';
import { Box, TextField, Button, MenuItem, Divider } from '@mui/material';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';
import MobileAddFab from '../common/search/MobileAddFab';

export const ProductListBox = ({
  downloadExl,
  uploadExl,
  handleAdd,
  formik,
}) => {
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: { xs: 'contents', sm: 'flex' },
            flexDirection: 'row',
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            alignItems: 'center',
            rowGap: 1,
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              order: { xs: 1, sm: 0 },
              flexBasis: { xs: '100%', sm: 'auto' },
              flex: { xs: '1 1 100%', sm: '0 1 auto' },
              minWidth: 0,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: { xs: 0.5, sm: 1 }, width: { sm: '25ch' } },
              '& > :first-of-type': { flex: { xs: '0 0 38%', sm: '0 1 auto' } },
              '& > :last-of-type': { flex: { xs: 1, sm: '0 1 auto' } },
            }}
          >
            <TextField
              variant="standard"
              required
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              <MenuItem value="">검색키워드</MenuItem>
              <MenuItem value="partnerNm">제조사</MenuItem>
              <MenuItem value="productLine">제품군</MenuItem>
              <MenuItem value="productNm">제품명</MenuItem>
              <MenuItem value="modelNm">모델명</MenuItem>
              <MenuItem value="category">아이템명</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required
              id="searchWords"
              name="searchWords"
              label="검색어"
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
              InputProps={{
                endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
              }}
            />
          </Box>

          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
        </Box>
        <Box textAlign="center" sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Button color="primary" variant="contained" onClick={handleAdd}>
            추가
          </Button>
        </Box>

        <Box
          sx={{
            order: { xs: 3, sm: 0 },
            flexBasis: { xs: '100%', sm: 'auto' },
            display: 'flex',
            flexDirection: 'row',
            justifyContent: { xs: 'flex-start', sm: 'center' },
            gap: { xs: 1, sm: 0 },
            mt: { xs: 0.5, sm: 0 },
          }}
        >
          <Box textAlign="center" sx={{ mx: { xs: 0, sm: 1 } }}>
            <Button
              variant="contained"
              color="success"
              onClick={downloadExl}
              sx={{
                fontSize: { xs: 12, sm: '0.875rem' },
                px: { xs: 1, sm: 2 },
                py: { xs: 0.5, sm: 0.75 },
                minWidth: { xs: 0, sm: 64 },
              }}
            >
              엑셀 다운로드
            </Button>
          </Box>
          <Box textAlign="center">
            <Button
              variant="contained"
              color="warning"
              onClick={uploadExl}
              sx={{
                fontSize: { xs: 12, sm: '0.875rem' },
                px: { xs: 1, sm: 2 },
                py: { xs: 0.5, sm: 0.75 },
                minWidth: { xs: 0, sm: 64 },
              }}
            >
              엑셀 업로드
            </Button>
          </Box>
        </Box>
        <MobileAddFab onClick={handleAdd} />
      </Box>
    </div>
  );
};
